const FooterBottom = () => {
  return (
    <div className="w-full py-0 bg-white text-center text-gray-400 text-sm">
      <p>
        © 2024. All rights reserved by 
        <a href="https://www.linkedin.com/in/tejas-sathe010/" className="text-gray-300 hover:text-white ml-1">
          Tejas Sathe
        </a>
      </p>
    </div>
  );
};

export default FooterBottom;
